import type { ActivityStatus } from '@brighterly/lib-core-types/booking/enums'
import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { useCsRoutes } from '@shared/api'

export interface UpdateLessonPayload {
  activity_status?: ActivityStatus
  device_type?: 'DESKTOP' | 'MOBILE'
}

interface UpdateLessonApiReturn {
  updateLesson: (bookingId: number, payload: UpdateLessonPayload) => Promise<Booking | null>
}

export const useUpdateLessonApi = (): UpdateLessonApiReturn => {
  const { $axios } = useNuxtApp()

  const updateLesson = async (bookingId: number, payload: UpdateLessonPayload): Promise<Booking | null> => {
    const url = useCsRoutes('classroom.lessons.update', {
      '[booking_id]': bookingId,
    })

    if (!url) {
      console.warn('missing url for classroom/update-lesson.hook.ts')
      return null
    }

    try {
      const { data } = await $axios.patch(url, { booking: payload })

      if (data?.success) {
        return (data?.data ?? null) as Booking | null
      }

      return null
    } catch (err: any) {
      console.error('unable to update classroom/update-lesson.hook.ts:', err)

      return null
    }
  }

  return { updateLesson }
}